import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '../../services/auth.service'

@Component({
    selector: 'ui-inline-profile',
    templateUrl: './inline-profile.component.html',
    styles: [
        `
            .inline-profile {
                text-align: center;
                padding: 1em 0;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineProfileComponent implements OnInit {
    constructor(private authService: AuthService, private router: Router) {}

    ngOnInit() {}

    logout() {
        this.authService.logout().subscribe(_ => this.router.navigateByUrl('/login'))
    }
}
